module.exports = __webpack_public_path__ + "static/img/money-04.942c66a.png";